// extracted by mini-css-extract-plugin
module.exports = {"layout":"e_C"};